import { defineMessages } from 'react-intl';

export default defineMessages({
    anErrorOccurred: {
        id: 'gw-portals-policytransaction-pc-pr.wizard.error',
        defaultMessage: 'Something went wrong during this process. Please try again.'
    },
    anErrorOccurredTitle: {
        id: 'gw-portals-policytransaction-pc-pr.wizard.error.title',
        defaultMessage: 'Error'
    },
    saveQuoteError: {
        id: 'gw-portals-policytransaction-pc-pr.Unable to quote',
        defaultMessage: 'Unable to quote'
    },
    saveQuoteErrorMessage: {
        id: 'gw-portals-policytransaction-pc-pr.An error occurred while attempting to quote.',
        defaultMessage: 'Something went wrong during this process. Please try again.'
    },
    wantToCancel:{
        id:'premier.policychange.pr.wizard.step.Are you sure you want to cancel?',
        defaultMessage:'Want to Cancel?'
    },
    infoWillBeSavedAsDraft:{
        id:'premier.policychange.pr.wizard.step.The information previously entered will be stored as a draft',
        defaultMessage:'The information previously entered will be stored as a draft'
    }
});
